import { render, staticRenderFns } from "./CreateUpdatePage.vue?vue&type=template&id=2edd804f&scoped=true"
import script from "./CreateUpdatePage.vue?vue&type=script&lang=js"
export * from "./CreateUpdatePage.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdatePage.vue?vue&type=style&index=0&id=2edd804f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edd804f",
  null
  
)

export default component.exports